import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styles from "./EventsList.scss";
import PublicEventContent from "../elements/PublicEventContent";
import Loader from "components/shared/elements/Loader";
import * as SiteActions from "actions/SiteActions";
import Calendar from "components/site/elements/Calendar";
import moment from "moment";


function EventsEventDetails(props) {
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        props.loadPublicEventDetails(props.eventId);
    }, [props.eventId]);

    if (!props.event) {
        return <Loader />
    }

    const handleCalendarClick = (calendarDate) => {
        history.push(`/calendar/${moment(calendarDate).format("YYYY-MM-DD")}`)
    }

    return (
        <div className={styles.root}>
            <div className={styles.root}>
                <div className={styles.content}>
                    <div className={styles.mainContainer}>
                        <PublicEventContent
                            event={props.event}
                        />
                    </div>
                    <div className={styles.sidebarContent}>
                        <div className={styles.sidebarInner}>
                            <div className={styles.topText}>
                                <Link to={"/"}>
                                    &lt; Back to All Classes & Events
                                </Link>
                            </div>
                            <Calendar
                                onClick={handleCalendarClick}
                                selectedDate={props.event.eventDate}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

EventsEventDetails.propTypes = {
    eventId: PropTypes.string.isRequired,
};

export default connect(
    (state, ownProps) => {
        const eventId = ownProps.match.params.eventId;
        return {
            eventId,
            event: state.site.events[eventId],
        };
    },
    (dispatch) => ({
        loadPublicEventDetails: (eventId) => dispatch(SiteActions.loadPublicEventDetails(eventId)),
    })
)(EventsEventDetails);
